import React, { useCallback, useMemo } from 'react';

import Dropdown, { DropdownMenu } from '@adsk/alloy-react-dropdown';
import FormField from '@adsk/alloy-react-form-field';
import Portal from '@adsk/alloy-react-portal';

import { useFormsContext } from './FormsProvider';
import { useTranslation } from './i18n';

const dropdownStyle = { width: '100%' };

const renderMenu = (menuProps, virtualProps) => (
  <Portal container={document.body}>
    {DropdownMenu.render(menuProps, virtualProps)}
  </Portal>
);

const TemplateFilter = ({ filters, onChangeFilter }) => {
  const { t } = useTranslation();
  const { formTemplates = [] } = useFormsContext();
  const templateOptions = useMemo(
    () =>
      formTemplates
        .filter((template) => template.uid || template.id)
        .map((template) => ({
          label: template.name,
          value: template.uid || template.id,
        })),
    [formTemplates],
  );
  const selectedTemplate =
    templateOptions.find((template) => template.value === filters.templateId) ||
    null;
  const handleSelectedItemChange = useCallback(
    ({ selectedItem }) => {
      onChangeFilter('templateId', selectedItem?.value || null);
    },
    [onChangeFilter],
  );

  return (
    <FormField
      label={t('TEMPLATE_NAME')}
      labelVariant={FormField.LABEL_VARIANTS.TOP}
    >
      <Dropdown
        style={dropdownStyle}
        items={templateOptions}
        selectedItem={selectedTemplate}
        renderMenu={renderMenu}
        onSelectedItemChange={handleSelectedItemChange}
      />
    </FormField>
  );
};

export default TemplateFilter;
